import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import privacyandpolicy from "../features/admin/masters/privacyandpolicy/Slice";
import termsandconditions from "../features/admin/masters/termsandconditions/Slice";
import blogs from "../features/admin/masters/blogs/Slice";
import finalthought from "../features/admin/masters/finalthought/Slice";
import banner from "../features/admin/masters/banner/Slice";
import propertytype from "../features/admin/masters/propertytype/Slice";
import subproperty from "../features/admin/masters/subproperty/Slice";
import furnishingtype from "../features/admin/masters/furnishingtype/Slice";
import parkingspace from "../features/admin/masters/parkingspace/Slice";
import bhk from "../features/admin/masters/bhk/Slice";
import floorpreference from "../features/admin/masters/floorpreference/Slice";
import legalquestion from "../features/admin/masters/legalquestion/Slice";
import stepfeature from "../features/admin/masters/stepfeature/Slice";
import security from "../features/admin/masters/security/Slice";
import restriction from "../features/admin/masters/restriction/Slice";
import saletype from "../features/admin/masters/saletype/Slice";
import amenity from "../features/admin/masters/amenity/Slice";
import property from "../features/admin/masters/property/Slice";
import appsetup from "../features/admin/masters/appsetup/Slice";
import subject from "../features/admin/masters/subject/Slice";
import review from "../features/admin/masters/review/Slice";
import project from "../features/admin/masters/project/Slice";
import purposeofappointment from "../features/admin/masters/purposeofappointment/Slice";
import riskassessment from "../features/admin/masters/riskassessment/Slice";
import propertymaking from "../features/admin/masters/propertymakingstatus/Slice";

const masters = combineReducers({
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  privacyandpolicy: privacyandpolicy,
  termsandconditions: termsandconditions,
  blogs: blogs,
  finalthought: finalthought,
  banner: banner,
  propertytype: propertytype,
  subproperty: subproperty,
  furnishingtype: furnishingtype,
  parkingspace: parkingspace,
  bhk: bhk,
  floorpreference: floorpreference,
  legalquestion: legalquestion,
  stepfeature: stepfeature,
  security: security,
  restriction: restriction,
  saletype: saletype,
  amenity: amenity,
  property: property,
  appsetup: appsetup,
  subject: subject,
  review: review,
  project: project,
  purposeofappointment: purposeofappointment,
  riskassessment: riskassessment,
  propertymaking: propertymaking,
});

export default masters;
